import styles from './PlusComponent.module.scss';

const PlusComponent = ({onClick}: {onClick: () => void}) => {
  return (
    <div onClick={onClick} className={styles.plus}>
      +
    </div>
  );
};

export default PlusComponent;
